import { defineComponent as _defineComponent } from 'vue'
import { Icons } from '@/icons/icons'
import { useI18n } from 'vue-i18n-composable'
import { PropType } from 'vue/types/v3-component-props'

// PROPS

export default /*#__PURE__*/_defineComponent({
  __name: 'CustomFieldsInfoTextComponent',
  props: {
  showInfoText: {
    type: Boolean as PropType<boolean>,
    default: true
  }
},
  emits: ['hide-info'],
  setup(__props, { emit }) {

const props = __props;



// TRANSLATIONS
const { t } = useI18n()
const text = {
  instructions: t('components.custom_fields_info_texts.instructions'),
  infoText: t('components.custom_fields_info_texts.info_text')
}

// DATA
const icon = {
  close: Icons.CLOSE,
  info: Icons.INFO_FULL
}

// EVENTS


// METHODS
function closeInfoText() {
  emit('hide-info')
}

return { __sfc: true,props, t, text, icon, emit, closeInfoText }
}

})